import React, { useContext } from 'react';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { AccessPageContext } from '../../common/types';
import { applicationSelector, hasPermissionsGate } from '../../common/utils';
import TableController from '../../controllers/table-controller';
import MainProviderContext from '../../services/access-page-context';
import ActorsTableDumb from './main';
import type { Props } from './types';
import { shouldDisplayIntro } from './utils';

export const ActorsTable = (props: Props) => {
	const {
		actors,
		tableFilters = {},
		onTableChange,
		isLastPage,
		onDataChange,
		intl,
		accessType = null,
		isFetching = false,
		hasPermissionsGate: permissionGate,
		...otherProps
	} = props;
	const context: AccessPageContext = useContext(MainProviderContext);
	const application = applicationSelector(context);
	const hasPermGate = permissionGate === true || hasPermissionsGate(context);

	return (
		<TableController
			actors={actors}
			tableFilters={tableFilters}
			onTableChange={onTableChange}
			isLastPage={isLastPage}
			onDataChange={onDataChange}
			isFetching={isFetching}
		>
			{({
				actors: actorsSubset,
				pagination,
				sorting,
				removeActor,
				onRolesUpdated,
				isFiltersApplied,
			}) => {
				const displayIntro = shouldDisplayIntro(accessType, actors, isFiltersApplied, isFetching);
				return (
					<ActorsTableDumb
						{...otherProps}
						application={application}
						hasPermissionsGate={hasPermGate}
						isThereActorInProject={
							isFiltersApplied && !isFetching && actors ? actors.length === 0 : false
						}
						sortKey={sorting.key}
						onSort={({ key, sortOrder }) =>
							sorting.onSort({
								key,
								order: sortOrder,
							})
						}
						isFetching={isFetching}
						sortOrder={sorting.order}
						page={pagination.currentPage}
						onPageChange={pagination.onPageChange}
						actors={actorsSubset}
						isLastPage={isLastPage}
						numberOfPages={pagination.numberOfPages}
						pageNumber={pagination.pageNumber}
						accessType={accessType}
						shouldDisplayIntro={displayIntro}
						removeActor={removeActor}
						onRolesUpdated={onRolesUpdated}
					/>
				);
			}}
		</TableController>
	);
};

ActorsTable.defaultProps = {
	isLastPage: true,
};

export default injectIntl(ActorsTable);
